import HeroSlider from '../components/HeroSlider';
import Presentation from '../components/Presentation';
import Features from '../components/Features';
import Promo from '../components/Promo';
import Contact from '../components/Contact';
import Testimonials from '../components/Testimonials';
import Pricing from '../components/Pricing';

export default function Home() {
  return (
    <main className="overflow-x-hidden">
      <HeroSlider />
      <Presentation />
      <Features />
      <Testimonials />
      <Promo />
      <Pricing />
      <Contact />
    </main>
  );
}
